import React, { useState, useContext, useEffect, useRef } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Card, Modal, Form, Button, Spinner } from 'react-bootstrap';
import { del } from '../api2';
import { AccountContext } from '../contexts';

export default function SettingsDeleteProfile({ profile, name }) {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const isModalClosable = useRef(true);
  const source = useRef();
  const accountContext = useContext(AccountContext);

  useEffect(() => {
    source.current = new Set();
    return () => {
      source.current.forEach(cancel => cancel());
    };
  }, []);

  const openModal = () => {
    setShowModal(true);
    setIsDeleting(false);
  };

  const closeModal = () => {
    if (!isModalClosable.current) return;
    setShowModal(false);
    setIsDeleting(false);
  };

  const deleteProfile = () => {
    isModalClosable.current = false;
    setIsDeleting(true);
    
    const cancel = del(`/profiles/${profile}`, () => {
      accountContext.onProfileDeleted(profile);
      closeModal();
    });

    source.current.add(cancel);
  };

  return (
    <>
      <Card body border="danger">
        <Button variant="danger" onClick={openModal}>
          <Trans i18nKey="settings.delete.button">
            {'_Delete '}
            <span className="notranslate" style={{ fontWeight: 'bold' }}>
              {{ name: name }}
            </span>
          </Trans>
        </Button>
        <Form.Text as="div" className="mt-2">
          {t('settings.delete.warning')}
        </Form.Text>
      </Card>

      <Modal show={showModal} animation={false} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Trans i18nKey="settings.delete.button">
              {'_Delete '}
              <span className="notranslate" style={{ fontWeight: 'bold' }}>
                {{ name: name }}
              </span>
            </Trans>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Trans i18nKey="settings.delete.confirm.text">
            {'_Are you sure you want to delete '}
            <span className="notranslate" style={{ fontWeight: 'bold' }}>
              {{ name: name }}
            </span>
            ? This action cannot be undone.
          </Trans>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" disabled={isDeleting} onClick={closeModal}>
            {t('global.cancel')}
          </Button>
          {!isDeleting ? (
            <Button variant="danger" onClick={deleteProfile}>
              {t('global.delete')}
            </Button>
          ) : (
            <Button variant="danger" disabled>
              <Spinner as="span" animation="border" size="sm" className="me-2" />
              {t('global.delete')}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}
